/**
 * Ksting
 *
 * Copyright © 2017 Chris Andersson <chris@wbisbi.com>. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React, { PureComponent } from 'react';
import { arrayOf, shape, string } from 'prop-types';

import CtaImage001 from '../../../../media/jpg/cta-image-001.jpg';
import CtaImage002 from '../../../../media/jpg/cta-image-002.jpg';
import CtaImage003 from '../../../../media/jpg/cta-image-003.jpg';
import CtaImage004 from '../../../../media/jpg/cta-image-004.jpg';
import CtaImage006 from '../../../../media/jpg/cta-image-006.jpg';
import CtaImage007 from '../../../../media/jpg/cta-image-007.jpg';

import Button from 'components/Button/Button';

import styles from './cta-block.scss';

/**
 * This is the CtaBlock component.
 *
 * @author Chris Andersson <chris@wbisbi.com>
 * @author Pelle Lundgren <pelle.lundgren@vntrs.com>
 *
 */
export default class CtaBlock extends PureComponent {
  /**
   * Declare expected prop types.
   *
   * @type {object}
   */
  static propTypes = {
    title: string.isRequired,
    content: string.isRequired,
    image: string,
    buttons: arrayOf(
      shape({
        text: string,
        url: string,
      })
    ),
    align: string,
  };

  static defaultProps = {
    image: null,
    buttons: [],
    align: null,
  };

  /**
   * Render CtaBlock.
   *
   * @return {Object}
   */
  render() {
    const { title, content, buttons, image } = this.props;
    const [talenButton, clientButton] = buttons;

    // This one is a bit odd and require some explanations.
    // The orginal setup the image url comes from bootstrap json.
    // Since bootstrap json needs to be released to get updated and the CTA block is reused on several places
    // and we didn't have access to Cloudinary and we had to update the images,
    // the lookup function saw the light of the day.
    // To be clean up to not rely on the bootstrap later.

    function getImage(image) {
      switch (image) {
        case 'https://res.cloudinary.com/ksting/w_800,q_80/v1585044750/cta-laptop-5.jpg': {
          return CtaImage001;
        }
        case 'https://res.cloudinary.com/ksting/c_mfit,q_100,w_400,e_replace_color:black/v1566545755/cta-staff-lg2-nobg-brown.png': {
          return CtaImage002;
        }
        case 'https://res.cloudinary.com/ksting/c_mfit,q_100,w_400/v1574595408/cta-laptop1.jpg': {
          return CtaImage003;
        }
        case 'https://res.cloudinary.com/ksting/c_mfit,q_100,w_400,e_replace_color:black/v1566545753/cta-money-nobg-brown.png': {
          return CtaImage004;
        }
        case 'https://res.cloudinary.com/ksting/c_mfit,q_100,w_400,e_replace_color:black/v1566545753/cta-money-nobg-brown.png': {
          return CtaImage004;
        }
        case 'https://res.cloudinary.com/ksting/c_mfit,q_100,w_400,e_replace_color:black/v1566545753/cta-payment3-nobg-brown.png': {
          return CtaImage006;
        }
        case 'https://res.cloudinary.com/ksting/c_mfit,q_100,w_400,e_replace_color:black/v1566545754/cta-power-small-nobg-brown.png': {
          return CtaImage007;
        }
        default: {
          return CtaImage001;
        }
      }
    }

    return (
      <div className={styles.wrapper}>
        <div className={styles.textBlock}>
          <div>
            <h2>{title}</h2>
            <p dangerouslySetInnerHTML={{ __html: content }} />
            {buttons.length > 0 && (
              <div className={styles.buttons}>
                <div className={styles.button}>
                  <Button path={clientButton.url}>{clientButton.text}</Button>
                </div>
                <div className={styles.button}>
                  <Button dark ghost path={talenButton.url}>
                    {talenButton.text}
                  </Button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={styles.imageBlock}>
          <img
            className={styles.image}
            src={getImage(image)}
            alt="KSTING talents"
          ></img>
        </div>
      </div>
    );
  }
}
